
import { ChevronDownIcon } from 'vue-feather-icons'
import { capitalizeFirstLetter } from '~/fc/Helpers/StringHelpers'
export default {
  name: 'DashboardSidebar',
  components: {
    ChevronDownIcon,
    ShoppingCartIcon: () => import(/* webpackChunkName: "Icons" */ './ui/icon/ShoppingCartIcon'),
    LayersIcon: () => import(/* webpackChunkName: "Icons" */ './ui/icon/LayersIcon'),
    BriefcaseIcon: () => import(/* webpackChunkName: "Icons" */ './ui/icon/BriefcaseIcon'),
    UserIcon: () => import(/* webpackChunkName: "Icons" */ './ui/icon/UserIcon'),
    KeyIcon: () => import(/* webpackChunkName: "Icons" */ './ui/icon/KeyIcon'),
    FileTextIcon: () => import(/* webpackChunkName: "Icons" */ './ui/icon/FileTextIcon'),
    BellIcon: () => import(/* webpackChunkName: "Icons" */ './ui/icon/BellIcon'),
    ActivityIcon: () => import(/* webpackChunkName: "Icons" */ './ui/icon/ActivityIcon'),
    AnchorIcon: () => import(/* webpackChunkName: "Icons" */ './ui/icon/AnchorIcon'),
    UsersIcon: () => import(/* webpackChunkName: "Icons" */ './ui/icon/UsersIcon'),
    AlertCircleIcon: () => import(/* webpackChunkName: "Icons" */ './ui/icon/AlertCircleIcon'),
    CreditCardIcon: () => import(/* webpackChunkName: "Icons" */ './ui/icon/CreditCardIcon'),
    SlidersIcon: () => import(/* webpackChunkName: "Icons" */ './ui/icon/SlidersIcon'),
    Logo: () => import(/* webpackChunkName: "Logo" */ '~/components/ui/Logo')
  },
  data: () => ({
    items: [
      {
        label: 'Billing',
        category: true
      },
      {
        icon: 'ShoppingCartIcon',
        url: '/account/billing-plan',
        label: 'Billing Plan'
      },
      {
        icon: 'CreditCardIcon',
        url: '/account/payment-method',
        label: 'Payment Method'
      },
      {
        icon: 'FileTextIcon',
        url: '/account/invoices',
        label: 'Invoice'
      },
      {
        label: 'API',
        category: true
      },
      {
        icon: 'LayersIcon',
        url: '/account/tasks',
        label: 'Tasks'
      },
      {
        icon: 'BriefcaseIcon',
        url: '/account/jobs',
        label: 'Jobs'
      },
      {
        icon: 'KeyIcon',
        url: '/account/api-tokens',
        label: 'API Keys'
      },
      {
        icon: 'AnchorIcon',
        url: '/account/webhooks',
        label: 'Webhooks'
      },
      {
        label: 'Settings',
        category: true
      },
      {
        icon: 'UserIcon',
        url: '/account',
        label: 'Account'
      },
      {
        icon: 'SlidersIcon',
        url: '/account/presets',
        label: 'Presets'
      },
      {
        icon: 'BellIcon',
        url: '/account/notifications',
        label: 'Notifications'
      },
      {
        icon: 'UsersIcon',
        url: '/account/team',
        label: 'Team'
      },
      {
        icon: 'ActivityIcon',
        url: '/account/activity',
        label: 'Activity'
      },
      {
        icon: 'AlertCircleIcon',
        url: '/account/faq',
        label: 'FAQ'
      }

    ],
    hoverItem: null,
    loading: true
  }),
  head () {
    return {
      title: (this.selectedItem ? this.selectedItem.label : this.pageTitle) + ' - FreeConvert.com'
    }
  },
  computed: {
    selectedItem () {
      return this.items.find(item => this.$route.path === item.url)
    },
    pageTitle () {
      const path = this.$route.fullPath.substring(this.$route.fullPath.lastIndexOf('/') + 1)
      return path.split('-').map(x => capitalizeFirstLetter(x)).join(' ')
    }
  },
  mounted () {
    this.hoverItem = this.selectedItem
    setTimeout(() => { this.loading = false }, 500)
  },
  methods: {
    isActivePath (url) {
      return this.$route.path === url || this.$route.path === url + '/'
    },
    isActive (childs) {
      return childs.some(item => this.$route.path.includes(item.url))
    },
    go (path) {
      if (this.isActivePath(path)) {
        location.reload()
      } else {
        this.$router.push(this.localePath(path))
      }
      if (window.innerWidth < 992) {
        this.$store.commit('toogleSidebar')
      }
    }
  }
}
